import React from 'react';
import { Tooltip, Typography } from 'antd';
import styled from '@emotion/styled';
import { BenefitType } from '../../../../types/benefit';

interface ColumnProps {
  record: BenefitType;
}
const LINK_TYPE: any = {
  WEB_LINK: 'Web Link',
  DEEP_LINK: 'App Deep Link',
};

export default React.memo((props: ColumnProps) => {
  const { record } = props;
  const type = record?.linkType || 'WEB_LINK';
  const textLink = LINK_TYPE[type];

  return (
    <StyledPartnerContainer>
      <Tooltip placement="topLeft" title={textLink}>
        <Typography.Text>{textLink}</Typography.Text>
      </Tooltip>
    </StyledPartnerContainer>
  );
});

const StyledPartnerContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: center;
  justify-content: center;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
